/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 *  atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Nodes} from "../Objects/Nodes.jsx";
import DisplayJson from "./DisplayJSON.jsx";

class DisplayPlannedConfig extends Component {
    constructor() {
        super();
        this.state = {
            config: []
        }
    }

    async fetchData() {
        let {nodeId} = this.props
        let result = await Nodes(nodeId).getPlannedConfig()
        this.setState({config: result?.config ?? result ?? []})
    }

    componentDidMount() {
        this.fetchData()
        this.interval = setInterval(() => {
            this.fetchData()
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.nodeId !== this.props.nodeId) {
            this.fetchData()
        }
    }


    render() {

        return (
            <div className={" w-full"}>
                <DisplayJson jsonInput={this.state.config}/>
            </div>
        );
    }
}

DisplayPlannedConfig.propTypes = {};

DisplayPlannedConfig.defaultProps = {};


export default DisplayPlannedConfig;